export default __webpack_public_path__ + "static/media/chevrons-right.4991bb9f.svg";